import Slider from "react-slick";
import React from "react";
import Feedbacknew from "./Feedbacknew";
import Qouta from "../Home/Qouta";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";

function Myabout() {
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,

    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // cssEase: "ease-in-out",
    // fade: true,
  };
  return (
    <div>
      <Header />
      {/* <!-- Start Page Banner Area --> */}
      <div class="page-banner-area mt-5">
        <div class="container pt-4">
          <div class="page-banner-content">
            <h1>
              <b>About Company</b>
            </h1>
            <ul class="list">
              <li>
                <a href="/">Home</a>
              </li>
              <li>About</li>
            </ul>
          </div>
        </div>
      </div>
      {/* <!-- End Page Banner Area --> */}

      {/* <!-- Start Rent Area --> */}
      <div class="rent-area pb-120">
        <div class="container-fluid">
          <div class="row justify-content-center" data-cues="slideInUp">
            <div class="col-lg-6 col-md-12 pt-50">
              <div class="rent-content">
                <span class="sub">Gateway LANDMARK GROUP</span>
                <h2>
                  <b>Who We Are?</b>
                </h2>
                <p>
                  Gateway Landmark Grouphas been offering world class luxury
                  properties in Jaipur for over 35 years and ranked among the
                  top real estate companies in Jaipur. Our expertise in
                  residential and commercial properties with great amenities at
                  prime locations of the city.
                  <br />
                  We offer multiple real estate investment options in multiple
                  development projects of residential and commercial properties
                  that go up to customer expectations. With a team of 50+
                  professional and industry experts, Gateway Landmark Grouphas
                  built a reputation for reliability, trust, and excellence in
                  the real estate sector.
                </p>
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="rent-image"></div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End Rent Area --> */}
      {/* <!-- Start Rent Area --> */}
      <div class="rent-area pt-100 pb-100">
        <div class="container-fluid">
          <div class="row justify-content-center" data-cues="slideInUp">
            <div class="col-lg-6 col-md-12">
              <div class="rent-image-2"></div>
            </div>
            <div class="col-lg-6 col-md-12 pt-100">
              <div class="rent-content">
                <span class="sub">Gateway LANDMARK GROUP</span>
                <h2>
                  <b>OUR VISION & MISSION</b>
                </h2>
                <h3>We build – We Master – We Care.</h3>
                <p>
                  Our vision is to be recognized as Jaipur’s leading real estate
                  developer, renowned for excellence, integrity, and innovation.
                  We aim to redefine the real estate experience by offering
                  luxurious, functional, and sustainable properties that cater
                  to the evolving needs of modern families and individuals.
                  Inspired by the challenges people face when buying property or
                  making real estate decisions, our mission is to address these
                  issues with a focus on transparency, trust, and customer
                  satisfaction.
                  <br />
                  By understanding your needs and priorities, we ensure a
                  seamless and rewarding experience, whether you’re investing in
                  real estate or purchasing residential or commercial
                  properties. Our dedicated team of professionals works
                  tirelessly to make every step easy, clear, and reliable,
                  helping you turn your real estate aspirations into reality.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Start Quote Area --> */}
      {/* <div class="quote-area  pb-100">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center" data-cues="slideInUp">
                <div class="col-lg-7 col-md-12">
                    <div class="swiper quote-slider">
                    
                        <div class="swiper-wrapper">
                        <Slider {...settings}>
                            <div class="swiper-slide">
                                <div class="quote-content">
                                    <img src="/img/quote.svg" class="quote" alt="quote"/>
                                    <h2>Where Vision Meets Realty Crafting Your Perfect Home</h2>
                                    <div class="info">
                                        <div class="image">
                                            <img src="/img/user1.png" alt="image"/>
                                        </div>
                                        <div class="title">
                                            <h3>Jordan Williams</h3>
                                            <span>Commercial Property Manager</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="quote-content">
                                    <img src="/img/quote.svg" class="quote" alt="quote"/>
                                    <h2>Where Vision Meets Realty Crafting Your Perfect Home</h2>
                                    <div class="info">
                                        <div class="image">
                                            <img src="/img/user2.png" alt="image"/>
                                        </div>
                                        <div class="title">
                                            <h3>Jenny Loren</h3>
                                            <span>Residential Appraiser</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="quote-content">
                                    <img src="/img/quote.svg" class="quote" alt="quote"/>
                                    <h2>Where Vision Meets Realty Crafting Your Perfect Home</h2>
                                    <div class="info">
                                        <div class="image">
                                            <img src="/img/user3.png" alt="image"/>
                                        </div>
                                        <div class="title">
                                            <h3>Ashley Martin</h3>
                                            <span>Commercial Consultant</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </Slider>
                        </div>  
                    </div>
                </div>
                <div class="col-lg-5 col-md-12">
                    <div class="quote-fun-facts-box">
                        <div class="row justify-content-center g-0">
                            <div class="col-lg-6 col-sm-6">
                                <div class="box">
                                    <div class="d-flex align-items-center">
                                        <h3 class="counter">50</h3>
                                        <h3 class="text">K</h3>
                                    </div>
                                    <p>Our Happy Customers</p>
                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-6">
                                <div class="box">
                                    <div class="d-flex align-items-center">
                                        <h3 class="counter">98</h3>
                                        <h3 class="text">%</h3>
                                    </div>
                                    <p>Clients Satisfaction Rate</p>
                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-6">
                                <div class="box">
                                    <div class="d-flex align-items-center">
                                        <h3 class="counter">50</h3>
                                        <h3 class="text">L Sqft+</h3>
                                    </div>
                                    <p>Area Developed</p>
                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-6">
                                <div class="box">
                                    <div class="d-flex align-items-center">
                                        <h3 class="counter">85</h3>
                                        <h3 class="text">+</h3>
                                    </div>
                                    <p>Real Estate Agents</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> */}

      <Qouta />
      {/* <!-- End Quote Area --> */}

      {/* <!-- Start Feedback Area --> */}

      <Feedbacknew />
      <Footer />
      {/* <!-- End Feedback Area --> */}
    </div>
  );
}

export default Myabout;
